import { push } from '@/lib/googleTagManager'

// Cart abandonment tracking for contx (CART RECOVERY). Its collect.js scans
// the dataLayer from the OLDEST entry and returns the first one carrying a
// `contx` key, so putting state into the dataLayer breaks as soon as a second
// update happens within one page session (the stale first entry keeps
// winning). Instead, the current state is written to window.contx — the
// script's documented fallback source, re-read on every execution — and the
// dataLayer only carries bare custom events that make GTM re-fire the tag.
// The vendor spec requires every value to be a string.
export type ContxCartItem = {
  id: string
  page: string
  name: string
  image: string
  price: string
  count: string
}

export type ContxCvItem = {
  id: string
  name: string
  price: string
  count: string
}

const setContxState = (state: {
  user: { id: string }
  cart: { items: ContxCartItem[] }
  cv?: { items: ContxCvItem[] }
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const w = window as any

  // The GTM tag's installer snippet also writes to window.contx (trackingId),
  // so extend it rather than replacing it
  w.contx = w.contx || {}
  w.contx.user = state.user
  w.contx.cart = state.cart

  if (state.cv) {
    w.contx.cv = state.cv
  } else {
    // A leftover cv from a previous conversion would make the next cart
    // update look like another conversion
    delete w.contx.cv
  }

  // Log if not production
  if (process.env.NODE_ENV !== 'production') {
    console.log('[contx]', state)
  }
}

export const pushContxCartUpdateEvent = (
  email: string,
  items: ContxCartItem[],
) => {
  setContxState({
    user: { id: email },
    cart: { items },
  })

  push({ event: 'contx_cart_update' })
}

export const pushContxCvEvent = (email: string, items: ContxCvItem[]) => {
  setContxState({
    user: { id: email },
    cart: { items: [] },
    cv: { items },
  })

  push({ event: 'contx_cv' })
}
